import { render, staticRenderFns } from "./resultsRatio.vue?vue&type=template&id=456600f8&scoped=true"
import script from "./resultsRatio.vue?vue&type=script&lang=js"
export * from "./resultsRatio.vue?vue&type=script&lang=js"
import style0 from "./resultsRatio.vue?vue&type=style&index=0&id=456600f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456600f8",
  null
  
)

export default component.exports